import './App.css';
import StopWatchComponent from './components/StopWatch/StopWatchComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <StopWatchComponent />
      </header>
    </div>
  );
}

export default App;
